module.exports = __webpack_public_path__ + "media/frontend/svg/close-75f352ac9c4a676b9bdc5456986cff4b.svg";